import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PlgTokenService } from '../../services/plg-token.service';
import { UserSessionStateService } from '../../services/user-session-state.service';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
    private readonly plgToken = inject(PlgTokenService);
    private readonly sessionState = inject(UserSessionStateService);

    /** Drives the swap between the routed wizard and the in-app sign-up landing. */
    readonly signUpRequired$: Observable<boolean> = this.plgToken.signUpRequired$;

    /**
     * Drives the swap between the routed wizard and the session-expired
     * landing. Takes precedence over `signUpRequired$` in the template — the
     * BE explicitly identifies expiry via `extensions.code = "SESSION_EXPIRED"`,
     * so when both happen to be on at the same time the expiry CTA is the
     * accurate next step for the user.
     */
    readonly sessionExpired$: Observable<boolean> = this.sessionState.sessionExpired$;

    mobileNavOpen = false;

    toggleMobileNav(): void {
        this.mobileNavOpen = !this.mobileNavOpen;
    }

    closeMobileNav(): void {
        this.mobileNavOpen = false;
    }
}
